import store from "../../../store";
import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import GeneralVariables from "../../utils/GeneralVariables";
import BaseService from "../BaseService";
import axios from "axios";

class CustomerService extends BaseService {

    static url = "customers";
    static apis = {
        that: this,
        checkToken: function() {
            return this.that.url + "/checkToken";
        },
        getRequets: function(id, url) {
            return "customers" + "/" + id + "/requests";
        },
        getChats: function(id, url) {
            return "customers" + "/" + id + "/chats";
        },
        getRfpChats: function(id, url) {
            return "customers" + "/" + id + "/rfp_chats";
        },
        getBillingAddress: function(id, url) {
            return this.that.url + "/" + id + "/billing_address"
        },
        getShippingAddresses: function(id, url) {
            return this.that.url + "/" + id + "/shipping_addresses"
        },
        createBillingAddress: function(id, url) {
            return this.that.url + "/" + id + "/billing_address"
        },
        updateBillingAddress: function(id, url) {
            return this.that.url + "/" + id + "/billing_address"
        },
        createShippingAddress: function(id, url) {
            return this.that.url + "/" + id + "/shipping_address"
        },
        updateShippingAddress: function(id, url) {
            return this.that.url + "/" + id + "/shipping_address"
        },
        getListings: function(id, url) {
            return "customers" + "/" + id + "/listings";
        },
        getSales: function(id, url) {
            return "customers" + "/" + id + "/sales";
        },
        getOrders: function(id, url) {
            return "customers" + "/" + id + "/orders";
        },
        getCustomerWathclist: function(id) {
            return "customers" + "/" + id + "/watchlists";
        },
        contactUs: function() {
            return "customers/contact"
        },
        validateVat: function() {
            return "customers/validate_vat"
        },
        editMatchPercentage: function() {
            return "customers/match-percentage"
        }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("customers");
    }

    editMatchPercentage(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.editMatchPercentage(),
                    data: data,
                    method: "POST",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createBillingAddress(id, data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.createBillingAddress(id),
                    data: data,
                    method: "POST",
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully created !")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    checkToken() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.checkToken(),
                    method: "GET",
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    contactUs(data, params) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.contactUs(),
                    data: data,
                    method: "POST",
                    message: params.message,
                    showLoader: true,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    updateBillingAddress(id, data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.updateBillingAddress(id),
                    data: data,
                    method: "PUT",
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully Updated !")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    createShippingAddress(id, data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.createShippingAddress(id),
                    data: data,
                    method: "POST",
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully created !")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    updateShippingAddress(id, data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.updateShippingAddress(id),
                    data: data,
                    method: "PUT",
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully Updated !")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getBillingAddress(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getBillingAddress(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getShippingAddresses(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getShippingAddresses(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    validateVat(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.validateVat(),
                    method: "POST",
                    showLoader: true,
                    authorization: true,
                    data: data
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerRequests(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getRequets(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerListings(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getListings(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerSoldListings(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getSales(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerLiveListings(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getListings(id),
                    method: "GET",
                    showLoader: true,
                    params: { is_approved: 1, is_draft: 0, availibility_id: 4 },
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


    getCustomerChats(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getChats(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerRfpChats(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getRfpChats(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerOrders(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getOrders(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getCustomerWathclist(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: CustomerService.apis.getCustomerWathclist(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    async getDefaultLanguageAndCurrency()
    {
       
        let response  = await axios({url:GeneralVariables.VUE_APP_GEOLOCATION_API})
        let text = response.data
        
        let location_datails = text
        let language_and_currency_response = await axios({url: GeneralVariables.BACKEND+"api/v1.0/customers/language-and-currency/"+location_datails['country_name']})
        language_and_currency = language_and_currency_response.data
        
        let language_and_currency = language_and_currency
    
        language_and_currency.country_name = location_datails['country_name']
        return language_and_currency
    }
}

export default CustomerService;